const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Frequency Type",
    dataIndex: "frequency_type",
    render: defaultRender,
  },
  {
    title: "Submit Order",
    dataIndex: "frequency_order",
    render: defaultRender,
  },
  {
    title: "Submitted Date",
    dataIndex: "submittedDate",
    render: defaultRender,
  },
  {
    title: "Completed By",
    dataIndex: "completed_by",
    render: defaultRender,
  },
  {
    title: "Completion Document",
    dataIndex: "completionDocument",
    render: defaultRender,
  },
  {
    title: "Completion Notes",
    dataIndex: "completionNotes",
    render: defaultRender,
  },
  {
    title: "Completed Date",
    dataIndex: "completedDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
    fixed: "right",
  },
];

export default columns;
